import { render, staticRenderFns } from "./DidNotChangePassword.vue?vue&type=template&id=ec7bc1fe&scoped=true&"
import script from "./DidNotChangePassword.vue?vue&type=script&lang=js&"
export * from "./DidNotChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./DidNotChangePassword.vue?vue&type=style&index=0&id=ec7bc1fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7bc1fe",
  null
  
)

export default component.exports